
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React from "react";
import BrowserImage from "@vwpfs/mary-air-lib/assets/images/libs/air/browsers.png";
import NewVersion from "@vwpfs/mary-air-lib/assets/images/libs/air/newversion.png";
import { Div } from "@vwpfs/mary-air-lib/components/air/03-base/Div";
import { ThemePalette } from "@vwpfs/mary-air-lib/theme/_Types";
import { getText } from "@vwpfs/mary-air-lib/utils/translations/I18n";
import { ModalNotification } from "@vwpfs/mary-air-lib/components/air/09-views/03-modals/Notification";
import packageJson from "../../../package.json";

declare global {
    interface Document {
        documentMode?: any;
    }
}

/**
 *
 */
interface OwnProps {
}

/**
 *
 */
interface StateProps {
}


export interface DispatchProps {
    handleBrowserNotification: (message: string) => void;
    handleNewAppVersion: (message: string) => void;
    closeModal: (id: string) => void;
}

interface ModalProps {
    id: string;
    onClose: () => void;
    message: string;
}

export const ModalGenericWarning: React.FunctionComponent<ModalProps> = (props) => (
    <ModalNotification
        id={props.id}
        onCloseModal={props.onClose}
        message={props.message}>
        <React.Fragment>
            <Div>
                <img
                    src={BrowserImage}
                    alt="IE xD!"
                    style={{
                        maxWidth: "75px",
                        alignSelf: "center",
                        margin: "0 auto",
                        display: "block",
                        transform: "translateX(15px)",
                    }}
                />
            </Div>
            <div className="scl-b-h5 scl-b-h">
                {getText("mary.utils.verifycontext.browser-support",
                    "Browser support")}
            </div>
            <br />
            <p>
                {props.message}
            </p>
        </React.Fragment>
    </ModalNotification>
);

export const ModalNewVersionAvailable: React.FunctionComponent<ModalProps> = (props) => (
    <ModalNotification
        id={props.id}
        title={getText("mary.utils.verifycontext.newversion-title",
            "Notification")}
        onCloseModal={props.onClose}
        refreshButton
        message={props.message}
        theme={{
            palette: ThemePalette.BRAND_ACCENT,
        }}
    >
        <React.Fragment>
            <Div>
                <img
                    src={NewVersion}
                    alt="New App. Version"
                    style={{
                        maxWidth: "150px",
                        alignSelf: "center",
                        margin: "0 auto",
                        display: "block",
                        transform: "translateX(15px)",
                    }}
                />
            </Div>
            <div className="scl-b-h5 scl-b-h">
                {getText("mary.utils.verifycontext.newversion-description",
                    "New version available!")}
            </div>
            <br />
            <p style={{ whiteSpace: "pre-line" }}>
                {props.message}
            </p>
        </React.Fragment>
    </ModalNotification>
);

const checkBrowsers = (handleBrowserNotification: (message: string) => void) => {
    const isIe = false || !!document.documentMode;

    if (isIe) {
        handleBrowserNotification(getText("mary.utils.verifycontext.browsersupport-description",
            `We don't actively support this browser, because of security and UI/UX reasons. \n \n
            Please use one of the more modern browers like Chrome, Edge, Firefox or Safari.`) ?? "",
        );
    }
};

const semverGreaterThan = (versionA: string, versionB: string) => {
    const versionsA = versionA.split(/\./g);
    const versionsB = versionB.split(/\./g);
    while (versionsA.length || versionsB.length) {
        const a = Number(versionsA.shift());
        const b = Number(versionsB.shift());
        if (a === b) {
            continue;
        }
        return a > b || isNaN(b);
    }
    return false;
};

const checkAppVersion = (handleBrowserNotification: (message: string) => void) => {
    const isIe = false || !!document.documentMode;

    if (!isIe) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        fetch(`${import.meta.env.VITE_PUBLIC_URL ?? ""}/meta.json?${new Date().getTime()}`, { cache: "no-cache" })
            .then((response) => response.json())
            .then((meta) => {
                const latestVersion = meta.version;

                console.log(latestVersion, packageJson.version);
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                const shouldForceRefresh = semverGreaterThan(latestVersion, packageJson.version);
                if (shouldForceRefresh) {
                    const notificationMessage = `Er is een nieuwe versie ${latestVersion} van ${import.meta.env.VITE_APP_TITLE} beschikbaar. U zou moeten verversen om de laatste wijzigingen te krijgen.

Als u deze melding al eerder voorbij heeft zien komen, klik dan op vernieuwen.`;
                    console.log(notificationMessage);
                    handleBrowserNotification(notificationMessage);
                } else {
                    console.log(getText("mary.utils.verifycontext.version-message",
                        "{{app-name}} by Claude is running the latest version: v{{version}}",
                        {"version": latestVersion, "app-name": import.meta.env.VITE_APP_TITLE ?? "Application"}));
                }
            });
    }
};

/**
 *
 */
export type Props = React.PropsWithChildren<OwnProps & StateProps & DispatchProps>;

/**
 * VerifyContext implements Claude's root component.
 */
export class VerifyContext
    extends React.Component<Props, {}> {

    public constructor(props: Props) {
        super(props);
    }

    public componentDidMount() {
        checkBrowsers(this.props.handleBrowserNotification);
        checkAppVersion(this.props.handleNewAppVersion);
    }

    public render() {
        return this.props.children;
    }
}

export const testUtil = {
    checkBrowsers: checkBrowsers,
    genericWarningModal: ModalGenericWarning,
    newVersionAvailableModal: ModalNewVersionAvailable,
    semverGreaterThan: semverGreaterThan,
    checkAppVersion: checkAppVersion,
};
